import React from 'react';
import { CostPerBlockFeature, ConcurrentCCRFeature } from './SharedApiFeatures';
import CheckOrCross from '../Shared/CheckOrCross';

const FEATURE_NAME = 'stt-sync';

const sttRealtimeFeatures = ({ packages, sttConfig }) => ({
  enabled: {
    key: 'stt-realtime-enabled',
    label: 'sttRealtime',
    values: packages.map((pkg) => (
      <CheckOrCross
        key={pkg.code}
        isCheck={!!pkg?.features?.includes(FEATURE_NAME)}
      />
    )),
  },
  costPerBlock: {
    key: 'stt-realtime-cost-per-block',
    label: 'costPerBlock',
    values: packages.map((pkg) => (
      <CostPerBlockFeature
        key={pkg.code}
        pkg={pkg}
        creditPerBlock={sttConfig?.creditPerBlock}
        featureName="stt-sync"
      />
    )),
  },
  concurrentCCR: {
    key: 'stt-realtime-ccr',
    label: 'concurrentAPIRequests',
    values: packages.map((pkg) => (
      <ConcurrentCCRFeature
        key={pkg.code}
        pkg={pkg}
        ccr={pkg?.apiCcr?.stt?.sync}
      />
    )),
  },
});

export default sttRealtimeFeatures;
